import MakerStarter from "./scripts/MakerStarter";

new MakerStarter();
